import MediaNotAvailable from '@components/media_not_available';
import { Img } from '@xo-union/tk-component-picture';
import React from 'react';
import type { Raw } from 'types/vendor';
import { getVendorImage } from '../../../utils/transformNetworkData';
import Styles from './TwoVendorImageGrid.scss';

interface TwoVendorImageGridProps {
	vendors: Raw[];
}

export const TwoVendorImageGrid: React.FC<TwoVendorImageGridProps> = ({
	vendors,
}) => {
	const vendorsWithImages = vendors
		.map((vendor) => ({
			vendor,
			image: getVendorImage(vendor),
		}))
		.filter((item) => item.image !== null)
		.slice(0, 2);

	if (vendorsWithImages.length === 0) {
		return (
			<div
				className={Styles.placeholderWrapper}
				data-testid="celebration-photo-grid-placeholder"
			>
				<MediaNotAvailable />
			</div>
		);
	}

	return (
		<div
			className={Styles.twoVendorsLayout}
			data-testid="celebration-photo-grid-layout2"
		>
			<div
				className={Styles.mainImage}
				data-testid="celebration-photo-grid-main-image"
			>
				{vendorsWithImages[0] && (
					<Img
						src={vendorsWithImages[0].image as string}
						alt={vendorsWithImages[0].vendor.name}
						className={Styles.image}
						smartCrop
						data-testid="celebration-photo-grid-image-0"
					/>
				)}
			</div>
			<div
				className={Styles.sideImages}
				data-testid="celebration-photo-grid-side-images"
			>
				{vendorsWithImages[1] && (
					<div
						className={Styles.sideImage}
						data-testid="celebration-photo-grid-side-image"
					>
						<Img
							src={vendorsWithImages[1].image as string}
							alt={vendorsWithImages[1].vendor.name}
							className={Styles.image}
							smartCrop
							data-testid="celebration-photo-grid-image-1"
						/>
					</div>
				)}
			</div>
		</div>
	);
};
